module.exports = __webpack_public_path__ + "static/img/404.a57b6f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error/404.png
// module id = d8X2
// module chunks = 1